const reconnectDelay = 400;
const maxReconnectTimeout = 1000;

const getMaxReconnectTimerId = (resolve) => setTimeout(() => resolve(false), maxReconnectTimeout);

module.exports = fox => ({
	reconnectSockets() {
		const root = fox.wom.getRoot();
		const socket = root.wom1('#socket');
		const chatsocket = root.wom1('#uchatctrl');
		const promises = [];

		if (socket) {
			promises.push(
				new fox.Promise(resolve => setTimeout(() => {
					const timerId = getMaxReconnectTimerId(resolve);

					root.wait(socket, 'socketReady', {
						prefix: 'reconnect_socket_mixin'
					}).then(() => {
						clearTimeout(timerId);

						return resolve(true);
					});

					socket.socket.disconnect();
				}, reconnectDelay))
			);
		}

		if (chatsocket) {
			promises.push(
				new fox.Promise(resolve => setTimeout(() => {
					const timerId = getMaxReconnectTimerId(resolve);

					chatsocket.reconnect().then(() => {
						clearTimeout(timerId);

						return resolve(true);
					});
				}, reconnectDelay))
			);
		}

		return promises.length && fox.Promise.all(promises).then((results) => {
			return true/* results.every(result => result) waiting for socket fix */;
		}) || fox.Promise.resolve(false);
	}
});


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/widget/mixin/socketsReconnect.es.js